import ReactMarkdown from 'react-markdown';
import { NavLink } from 'react-router-dom';
import { Link } from '@mui/material';

const Markdown = (props) => (
	<ReactMarkdown
		components={{
		    a: ({node, ...others}) => {
		    	const url =  new URL(node.properties.href);
		    	let action = {};
		    	if(url.hostname.includes("chefincamicia")) {
		    		action = {
		    			to: url.pathname + url.search,
		    			component: NavLink
		    		};
		    	} else {
		    		action = {
		    			href: node.properties.href,
		    			target: '_blank'
		    		};
		    	}
		    	return (
		    		<Link 
		    			underline="hover" 
		    			sx={{fontWeight: 'bold'}} 
		    			{...action}
		    			{...others} 
		    		/>
		    	)
		    }
		}}
		{...props}
	/>
);

export default Markdown;